import React from "react";
import PropTypes from "prop-types";
import { Box, Button, Skeleton, Typography } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import { Icon } from "@iconify/react";
import { EcgCard } from "../../../components/Ecgview/Card";

function ReportsCardView({
  reports,
  isLoading,
  totalCount,
  hasMore,
  listRef,
  onScroll,
  onSelectReport,
  selectedReportId,
  openedMap,
  onExport,
}) {
  return (
    <div
      className="col-md-4"
      style={{
        maxHeight: "70vh",
        paddingBottom: "20px",
        overflowY: "scroll",
        borderRight: "1px solid var(--app-border)",
      }}
      onScroll={onScroll}
      ref={listRef}
    >
      <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1.75 }}>
        <Typography sx={{ color: "var(--app-text)", fontFamily: "Figtree", fontWeight: 700, fontSize: 20 }}>
          Reports List{" "}
          <Typography component="span" sx={{ color: "var(--app-text-muted)", fontFamily: "Figtree", fontSize: 14, fontWeight: 600 }}>
            ({totalCount})
          </Typography>
        </Typography>
        <Button
          variant="text"
          size="small"
          onClick={onExport}
          disabled={!totalCount}
          startIcon={<Icon icon="material-symbols:download" width="18" height="18" />}
          sx={{ color: "var(--app-accent)", fontFamily: "Figtree", fontSize: 14, fontWeight: 700, textDecoration: "underline", textTransform: "none" }}
        >
          Export CSV
        </Button>
      </Box>

      {isLoading && reports.length === 0 ? (
        <Box sx={{ mt: 1 }}>
          {[1, 2, 3, 4, 5].map((item) => (
            <Box key={item} sx={{ mb: 2, p: 2, borderRadius: 3, backgroundColor: "var(--app-surface)", boxShadow: "var(--app-shadow)" }}>
              <Skeleton variant="text" width="55%" height={24} animation="wave" />
              <Skeleton variant="text" width="70%" height={18} animation="wave" />
              <Skeleton variant="text" width="45%" height={18} animation="wave" />
            </Box>
          ))}
        </Box>
      ) : (
        reports.map((report, index) => (
          <EcgCard
            key={report._id || report?.report?.id}
            data={report}
            selectreport={() => onSelectReport(report, index)}
            is_current={String(report?.report?.id) === String(selectedReportId)}
            isOpened={openedMap[report?.report?.id] ?? report?.isOpened}
          />
        ))
      )}

      {isLoading && reports.length > 0 && (
        <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
          <CircularProgress size={24} thickness={4} />
        </Box>
      )}

      {!hasMore && reports.length > 0 && (
        <Typography textAlign="center" variant="body2" color="text.secondary">
          No more reports
        </Typography>
      )}
    </div>
  );
}

export default ReportsCardView;

ReportsCardView.propTypes = {
  reports: PropTypes.array.isRequired,
  isLoading: PropTypes.bool.isRequired,
  totalCount: PropTypes.number.isRequired,
  hasMore: PropTypes.bool.isRequired,
  listRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  onScroll: PropTypes.func.isRequired,
  onSelectReport: PropTypes.func.isRequired,
  selectedReportId: PropTypes.string,
  openedMap: PropTypes.object.isRequired,
  onExport: PropTypes.func.isRequired,
};
